import { CustomViewEntity } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';

export const CUSTOM_VIEWS_AVAILABLE_ICONS = [
  'inbox',
  'all_inbox',
  'task',
  'checklist',
  'home',
  'assignment_ind',
  'group_work',
  'insights',
  'priority_high',
  'schedule_send',
  'report',
  'analytics',
  'trending_up',
  'trending_flat',
  'event_available',
  'flag',
  'browse_gallery',
  'deployed_code',
  'hourglass_disabled',
  'support_agent',
  'bug_report',
  'warning_amber',
  'report_problem',
  'task_alt',
  'stars',
  'label_important',
  'event_note',
  'policy',
  'public',
  'device_thermostat',
  'bolt',
  'attach_money',
  'check_circle',
  'dashboard',
  'keep',
  'folder',
];

export const MAP_URL_ENTITY_NAME_TO_ENTITY = {
  conversations: EntityNames.Conversation,
  projects: EntityNames.Project,
  sites: EntityNames.Site,
  clients: EntityNames.Client,
} as Record<string, CustomViewEntity>;

export const MAP_ENTITY_TO_URL_ENTITY: Record<CustomViewEntity, string> = Object.entries(
  MAP_URL_ENTITY_NAME_TO_ENTITY,
).reduce(
  (acc, [to, from]) => ({ ...acc, [from]: to }),
  {} as Record<CustomViewEntity, string>,
);

export const PLATFORM_PARTNER_HIDDEN_VIEW_TABS: CustomViewEntity[] = [
  EntityNames.Client,
];
